var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_20)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.36888 1.83325H12.5915C12.9167 1.83325 13.2313 1.94846 13.4795 2.15843L17.8461 5.85187C18.155 6.11312 18.3332 6.49714 18.3332 6.90169V18.4096C18.3332 20.051 18.3144 20.1666 16.6308 20.1666H5.36888C3.68525 20.1666 3.6665 20.051 3.6665 18.4096V3.5902C3.6665 1.94887 3.68525 1.83325 5.36888 1.83325Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.3a5b2811ca7e96bd51a7431a28cdd0ca.svg";
export { ForwardRef as ReactComponent };